import styled from "@emotion/styled";

export const Elevation = styled.div`
  width: 100%;
  padding: 16px;
  margin-top: 24px;
  overflow-x: auto;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12);
  border-radius: 4px;
  background-color: #fff;
`;
